import React, { useState } from 'react';
import { useTranslations } from 'next-intl';
import AddCustomerService from '@/components/commons/AddCustomerService';
import Head from '@/components/commons/Head';
import LatestNews from '@/components/home/LatestNews';

const InformationContent = () => {
  const t = useTranslations();
  // const informationList = [
  //   {
  //     image: '/images/information/information6.png',
  //     icon: '/images/home/bilibili.png',
  //     url: '',
  //   },
  //   {
  //     image: '/images/information/information1.png',
  //     icon: '/images/home/contactUsLogo.png',
  //     url: '',
  //   },
  //   {
  //     image: '/images/information/information2.png',
  //     icon: '/images/home/contactUsLogo.png',
  //     url: '',
  //   },
  //   // {
  //   //   image: '/images/information/information3.png',
  //   //   icon: '/images/home/xiaohongshu.png',
  //   //   url: '',
  //   // },
  //   // {
  //   //   image: '/images/information/information4.png',
  //   //   icon: '/images/home/xiaohongshu.png',
  //   //   url: '',
  //   // },
  //   // {
  //   //   image: '/images/information/information5.png',
  //   //   icon: '/images/home/xiaohongshu.png',
  //   //   url: '',
  //   // },
  // ];
  // const [screenWidth, setScreenWidth] = useState<number>(0);
  // const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const countryList = ['加拿大', '欧洲', '日本', '新加坡', '中国香港', '其他'];
  const [selectedCountryIndex, setSelectedCountryIndex] = useState<number>(0);
  // const [globalList, setGlobalList] = useState<any[]>([]);

  // useEffect(() => {
  //   setScreenWidth(window.innerWidth);

  //   const handleResize = () => {
  //     setScreenWidth(window.innerWidth);
  //   };

  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  // 获取10条全球热点数据
  // useEffect(() => {
  //   getAllPosts({ tags: 144 }).then((res) => {
  //     console.log('全球热点', res);
  //     setGlobalList(res?.data || []);
  //   });
  // }, []);

  return (
    <div className="w-full">
      <Head
        title={'海外资讯,全球热点,政策,专注移民留学'}
        description={
          '星环移民，专注加拿大移民和留学十余载，擅长量身定制方案，提供高性价比服务，成功率居行业领先水平。旗下拥有多位全职的ICCRC认证的「加拿大持牌移民顾问」、教育专家和职业培训导师，专业办理加拿大移民、留学、游学、夏令营、教育等服务，提供顾问咨询、签证办理、学校申请、就业指导、财税规划及新移民安家落地、置业创业等一条龙服务，对于解决各种签证、留学、移民疑难问题有丰富经验与成功案例。'
        }
        keywords="移民,海外移民,加拿大移民,全球移民,移民咨询,移民公司,移民中介,星环移民"
      />
      {/* 星环移民 最新资讯动态 */}
      <LatestNews className="mb-[4.8vw] pt-[4.316vw] max-md:mb-0" />
      {/* 资讯 */}

      <div className="box-border w-full px-[11.128vw] pb-[5.876vw] pt-[4.316vw] max-md:px-[30px] max-md:py-6">
        <div className="mb-[3.952vw] flex h-[3.9vw] w-full flex-row items-center justify-start border-b-[1px] border-solid border-[#D9D9D9] max-md:mb-4 max-md:h-10">
          {countryList.map((item, index) => {
            return (
              <h2
                key={index}
                className={`mr-[4.456vw] flex h-[3.9vw] cursor-pointer flex-row items-center justify-center px-[0.208vw] font-normal text-[#111111] last:mr-0 max-md:mr-4 max-md:h-10 ${
                  selectedCountryIndex === index
                    ? '-mb-1 border-b-[5px] border-solid border-[#FFBB4C] text-[1.248vw] leading-[1.248vw] max-md:border-b-2 max-md:text-sm'
                    : 'text-[0.936vw] leading-[0.936vw] max-md:text-[13px]'
                }`}
                onClick={() => setSelectedCountryIndex(index)}
              >
                {t(`Information.country${index + 1}` as any)}
              </h2>
            );
          })}
        </div>
        {selectedCountryIndex === 0 ? (
          <div className="grid w-full grid-cols-3 gap-8 max-md:grid-cols-1">
            <div className="w-full">
              <h2 className="mb-[0.832vw] text-[1.248vw] font-medium leading-[1.248vw] text-[#212136] max-md:text-base">
                加拿大安居乐业
              </h2>
              <h2 className="mb-[1.664vw] text-[0.832vw] font-normal leading-[0.832vw] text-[#666666] max-md:text-sm">
                Tips for living in Canada
              </h2>
              <div className="box-border w-full bg-[#EBEBF6] px-[1.456vw] py-[1.872vw] max-md:p-4 max-md:px-3">
                {[
                  { title: '政府结构', englishTitle: 'Structure of Canadian Government', url: '/政府结构/' },
                  { title: '法制体系', englishTitle: 'Law system', url: '/法律体系/' },
                  { title: '福利介绍', englishTitle: 'Benefits in Canada', url: '' },
                  { title: '纳税政策', englishTitle: 'Tax Policy', url: '/纳税政策/' },
                  { title: '社区服务', englishTitle: 'Community Serivces', url: '/社区服务/' },
                  { title: '租房指南', englishTitle: 'Housing & Renting', url: '/加拿大租房指南/' },
                  { title: '就业创业', englishTitle: 'Work & Start-Up', url: '/就业创业/' },
                  { title: '医疗护理', englishTitle: 'Medical System', url: '/医疗系统/' },
                  { title: '出行指南', englishTitle: 'Tips for travel', url: '/出行指南/' },
                  { title: '租车购车与驾照', englishTitle: 'Vehicle & Licensing', url: '/租车购车与驾照/' },
                  { title: '紧急事故', englishTitle: 'Emergency', url: '' },
                  { title: '援助资源', englishTitle: 'Support & Aid', url: '/援助资源/' },
                ].map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="mb-[1.664vw] flex w-full cursor-pointer flex-row items-center justify-between last:mb-0 max-md:mb-2"
                      onClick={() => {
                        if (item.url) {
                          window.open(process.env.NEXT_PUBLIC_WEBSITE + item.url, '_blank');
                        }
                      }}
                    >
                      <h3
                        className={`w-2/5 truncate text-left text-[0.832vw] font-medium leading-[0.832vw] text-[#333333] max-md:text-[13px] max-md:leading-[13px] ${item.title === '政府结构' ? 'max-md:w-1/4' : 'max-md:w-1/3'}`}
                      >
                        {item.title}
                      </h3>
                      <h3
                        className={`w-3/5 truncate text-right text-[0.728vw] font-normal leading-[0.728vw] text-[#666666] max-md:text-[13px] max-md:leading-[13px] ${item.title === '政府结构' ? 'max-md:w-3/4' : 'max-md:w-2/3'}`}
                      >
                        {item.englishTitle}
                      </h3>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="w-full">
              <h2 className="mb-[0.832vw] text-[1.248vw] font-medium leading-[1.248vw] text-[#212136] max-md:text-base">
                加拿大各省介绍
              </h2>
              <h2 className="mb-[1.664vw] text-[0.832vw] font-normal leading-[0.832vw] text-[#666666] max-md:text-sm">
                List of Provinces in Canada
              </h2>
              <div className="box-border w-full bg-[#FEFAF7] px-[1.456vw] py-[1.872vw] max-md:p-4 max-md:px-3">
                {[
                  { title: '各省概况', englishTitle: 'Overview of Provinces', url: '/overview-of-canada/各省介绍/' },
                  {
                    title: '阿尔伯塔省',
                    englishTitle: 'Albeta',
                    url: '/overview-of-canada/各省介绍/alberta-introduction/',
                  },
                  {
                    title: '不列颠哥伦比亚省',
                    englishTitle: 'British Columbia',
                    url: '/overview-of-canada/各省介绍/britisih-columbia/',
                  },
                  {
                    title: '曼尼托巴省',
                    englishTitle: 'Manitoba',
                    url: '/overview-of-canada/各省介绍/manitoba-introduction/',
                  },
                  {
                    title: '新不伦瑞克省',
                    englishTitle: 'New Brunswick',
                    url: '/overview-of-canada/各省介绍/new-brunswick-introduction/',
                  },
                  {
                    title: '新斯科舍省',
                    englishTitle: 'Nova Scotia',
                    url: '/overview-of-canada/各省介绍/nova-scotia-新斯科舍/',
                  },
                  {
                    title: '纽芬兰拉布拉多省',
                    englishTitle: 'Newfoundland&Labrador',
                    url: '/overview-of-canada/各省介绍/newfoundland-labrador-纽芬兰省/',
                  },
                  {
                    title: '西北地区',
                    englishTitle: 'NorthWest Terrtories',
                    url: '/overview-of-canada/各省介绍/northwest-territories-西北行政区/',
                  },
                  { title: '安大略省', englishTitle: 'Ontario', url: '/overview-of-canada/各省介绍/安大略省介绍/' },
                  { title: '努纳武特地区', englishTitle: 'Nunavut', url: '/overview-of-canada/各省介绍/努纳武特/' },
                  {
                    title: '爱德华王子岛',
                    englishTitle: 'Prince Edward Island',
                    url: '/overview-of-canada/各省介绍/prince-edward-island-爱德华王子岛省/',
                  },
                  {
                    title: '魁北克省',
                    englishTitle: 'Québec',
                    url: '/overview-of-canada/各省介绍/quebec-魁北克/',
                  },
                  {
                    title: '萨斯喀彻温省',
                    englishTitle: 'Saskatchewan',
                    url: '/overview-of-canada/各省介绍/saskatchewan-萨斯克彻温/',
                  },
                  { title: '育空地区', englishTitle: 'Yukon', url: '/overview-of-canada/各省介绍/yukon-育空/' },
                ].map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="mb-[1.664vw] flex w-full cursor-pointer flex-row items-center justify-between last:mb-0 max-md:mb-2"
                      onClick={() => {
                        if (item.url) {
                          window.open(process.env.NEXT_PUBLIC_WEBSITE + item.url, '_blank');
                        }
                      }}
                    >
                      <h3
                        className={`w-2/5 truncate text-left text-[0.832vw] font-medium leading-[0.832vw] text-[#333333] max-md:text-[13px] max-md:leading-[13px]`}
                      >
                        {item.title}
                      </h3>
                      <h3
                        className={`w-3/5 truncate text-right text-[0.728vw] font-normal leading-[0.728vw] text-[#666666] max-md:text-[13px] max-md:leading-[13px]`}
                      >
                        {item.englishTitle}
                      </h3>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="w-full">
              <h2 className="mb-[0.832vw] text-[1.248vw] font-medium leading-[1.248vw] text-[#212136] max-md:text-base">
                加拿大教育概况
              </h2>
              <h2 className="mb-[1.664vw] text-[0.832vw] font-normal leading-[0.832vw] text-[#666666] max-md:text-sm">
                Canadian Education Overview
              </h2>
              <div className="box-border w-full bg-[#EBEBF6] px-[1.456vw] py-[1.872vw] max-md:p-4 max-md:px-3">
                {[
                  { title: 'K-12中小学教育', englishTitle: '', url: '' },
                  {
                    title: '中小学排名',
                    englishTitle: 'Ranking of Primary and Secondary Schools',
                    url: '/overview-of-canada/school-ranking-canada/',
                  },
                  {
                    title: '公立学校评分&分布图',
                    englishTitle: 'Public School Catchment Map',
                    url: '/大温公立中小学评分分布图/',
                  },
                  {
                    title: '公校概况',
                    englishTitle: 'Introduction of Public School',
                    url: '/overview-of-canada/education-in-canada/middle-school/',
                  },
                  {
                    title: '私校概况 ',
                    englishTitle: 'Introduction of Private School',
                    url: '/overview-of-canada/education-in-canada/education-analysis/canada-education-system-private-school-analysis/',
                  },
                  { title: '职业专科教育', englishTitle: '', url: '' },
                  { title: '普通大专', englishTitle: 'General College', url: '' },
                  { title: '艺术专科', englishTitle: 'Art College', url: '' },
                  { title: '航校专科', englishTitle: 'Flight College', url: '' },
                ].map((item, index) => {
                  if (item.title === 'K-12中小学教育' || item.title === '职业专科教育') {
                    return (
                      <div
                        key={index}
                        className="mb-[1.664vw] text-[0.936vw] font-medium leading-[0.936vw] text-[#333333] max-md:mb-2 max-md:text-sm"
                      >
                        {item.title}
                      </div>
                    );
                  }
                  return (
                    <div
                      key={index}
                      className="mb-8 flex w-full cursor-pointer flex-row items-center justify-between font-normal last:mb-0 max-md:mb-2"
                      onClick={() => {
                        if (item.url) {
                          window.open(process.env.NEXT_PUBLIC_WEBSITE + item.url, '_blank');
                        }
                      }}
                    >
                      <h3
                        className={`w-2/5 text-left text-[0.832vw] font-medium leading-[0.832vw] text-[#333333] max-md:w-1/2 max-md:text-[13px] max-md:leading-[13px] md:truncate`}
                      >
                        {item.title}
                      </h3>
                      <h3
                        className={`w-3/5 text-right text-[0.728vw] font-normal leading-[0.728vw] text-[#666666] max-md:w-1/2 max-md:text-[13px] max-md:leading-[13px] md:truncate`}
                      >
                        {item.englishTitle}
                      </h3>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full text-center text-[0.832vw] font-medium leading-[0.832vw] text-[#e2e2e2] max-md:text-sm">
            {t('Home.noData')}
          </div>
        )}
      </div>
      {/* 添加客服 */}
      <AddCustomerService />
    </div>
  );
};

export default InformationContent;
